/**
 * Brand: tropayment.com (storefront) + api.tropayment.com (API).
 */
export type BrandId = 'tropayment';

export interface BrandContext {
  id: BrandId;
  name: string;
  fullName: string;
  domain: string;
  siteUrl: string;
  apiUrl: string;
  supportEmail: string;
  /** Full wordmark — header, footer, marketing (logo.svg) */
  logoSrc: string;
  /** Square app icon — PWA, favicon, Google, notifications (icon.svg) */
  iconSrc: string;
  /** Raster icon for Google / OG (48px+ PNG) */
  iconPng192: string;
  iconPng512: string;
  logoAlt: string;
  /** @deprecated Use iconSrc */
  logoLetter: string;
  isCrypopay: boolean;
  /** Former / alternate names for SEO & schema.org (do not strip from keywords) */
  seoAlternateNames: readonly string[];
}

const TROPAYMENT: Omit<BrandContext, 'id' | 'isCrypopay'> = {
  name: 'tropayment',
  fullName: 'tropayment.com',
  domain: 'tropayment.com',
  siteUrl: 'https://tropayment.com',
  apiUrl: 'https://api.tropayment.com',
  supportEmail: 'support@tropayment.com',
  logoSrc: '/icons/logo.svg',
  iconSrc: '/icons/app-icon.png',
  iconPng192: '/icons/icon-192.png',
  iconPng512: '/icons/icon-512.png',
  logoAlt: 'tropayment',
  logoLetter: 'T',
  seoAlternateNames: [
    'tropayment',
    'tropayment.com',
    'Cryptopay',
    'cryptopay',
    'CryptoPay',
    'Crypto Pay',
    'Crypopay',
    'Crypopay.com',
  ],
};

export function resolveBrandId(_host?: string): BrandId {
  return 'tropayment';
}

export function getBrand(_host?: string): BrandContext {
  return { id: 'tropayment', isCrypopay: false, ...TROPAYMENT };
}

/** i18next default interpolation variables */
export function getBrandI18nVars(host?: string): Record<string, string> {
  const b = getBrand(host);
  return {
    brand: b.name,
    brandFull: b.fullName,
    brandDomain: b.domain,
  };
}

/** Replace legacy hardcoded strings in SEO/meta copy (display brand → tropayment) */
export function applyBrandToText(text: string, host?: string): string {
  const b = getBrand(host);
  return text
    .replace(/Tropayment\.com/gi, b.fullName)
    .replace(/\bTropayment\b/gi, b.name)
    .replace(/Crypopay\.com/gi, b.fullName)
    .replace(/\bCrypopay\b/gi, b.name)
    .replace(/Cryptopay\.com/gi, b.fullName)
    .replace(/CryptoPay/g, b.name)
    .replace(/\bCryptopay\b/gi, b.name);
}
